import { z } from 'zod'

export const trainerResourceLinkProbeExceptionResponseSchema = z.record(z.unknown())
export type TrainerResourceLinkProbeExceptionResponse = z.infer<typeof trainerResourceLinkProbeExceptionResponseSchema>
